// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__82QAo","content__image":"styles_content__image__SyJrJ","pulse":"styles_pulse__bi0jG","jump":"styles_jump__KVkkC","wiggle":"styles_wiggle__fn1N0"};